import { useEffect, useState } from "react";

export function padCountdown(n) {
  return String(n).padStart(2, "0");
}

/** @returns {{ days: number, hours: number, minutes: number, seconds: number } | null} */
export function useLaunchCountdown(launchAt) {
  const [parts, setParts] = useState(null);

  useEffect(() => {
    if (!launchAt) {
      setParts(null);
      return undefined;
    }

    const tick = () => {
      const target = new Date(launchAt).getTime();
      const diff = target - Date.now();
      if (!Number.isFinite(target) || diff <= 0) {
        setParts(null);
        return;
      }
      const totalSec = Math.floor(diff / 1000);
      setParts({
        days: Math.floor(totalSec / 86400),
        hours: Math.floor((totalSec % 86400) / 3600),
        minutes: Math.floor((totalSec % 3600) / 60),
        seconds: totalSec % 60,
      });
    };

    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [launchAt]);

  return parts;
}
